/*
 * Copyright (c) 2020 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Pipe, PipeTransform} from "@angular/core";
import {SelectItem} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  name: 'stringToSelectItems'
})
export class StringToSelectItemsPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: string [], path: any): SelectItem[] {

    const stringArray = value && Array.isArray(value) ? value : [];

    return stringArray.map(item => {
      return {
        label: this.translate.instant(`${path}.${item}`),
        value: item,
      }
    })
  }
}
